import React, { useEffect } from 'react';

import AdminSidebar from './AdminSidebar';

/**
 * 모바일 공고 관리 화면의 좌측 드로어.
 * 데스크탑 AdminSidebar 를 drawer 변형으로 그대로 쓰고, 상태를 고르면 드로어를 닫는다.
 */
const AdminMobileMenuDrawer = ({ isOpen, onClose, onChangeStatus, ...sidebarProps }) => {
  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = prevOverflow;
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  return (
    <>
      {/* 디자인 토큰 surface-black40은 실제 값이 0.64라 시안(0.40)과 달라 직접 지정한다 */}
      <div
        aria-hidden
        onClick={onClose}
        className={`fixed inset-0 z-[990] bg-[rgba(23,20,16,0.40)] transition-opacity duration-300 ease-[cubic-bezier(0.2,0,0,1)] motion-reduce:transition-none ${
          isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
      />
      <div
        role='dialog'
        aria-modal='true'
        aria-hidden={!isOpen}
        className={`fixed bottom-0 left-0 top-0 z-[995] w-[260px] overflow-y-auto bg-grayscale-gray00 py-[60px] transition-transform duration-300 ease-[cubic-bezier(0.2,0,0,1)] motion-reduce:transition-none ${
          isOpen ? 'translate-x-0' : '-translate-x-full pointer-events-none'
        }`}
      >
        <AdminSidebar
          {...sidebarProps}
          variant='drawer'
          onChangeStatus={(nextStatus) => {
            onChangeStatus(nextStatus);
            onClose();
          }}
        />
      </div>
    </>
  );
};

export default AdminMobileMenuDrawer;
